import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HeaderPopupSearch from './HeaderPopupSearch';
import MainMenu from './MainMenu';
import MobileMenu from './MobileMenu';
import logo from '../../assets/img/logo.svg';

const Header = () => {
  const { t, i18n } = useTranslation();
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const languages = ['en','fr','bn', 'hi', 'de','es'];
  const langLabels = { en: 'English', fr: 'French', bn: 'Bengali', hi: 'Hindi', de: 'German', es: 'Spanish' };
  const flagCodes = { en: 'us', fr: 'fr', bn: 'bd', hi: 'in', de: 'de', es: 'es'};
  const changeLang = (lng) => { if (typeof window !== 'undefined') localStorage.setItem('appLng', lng); i18n.changeLanguage(lng); };

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const saved = localStorage.getItem('appLng');
    if (saved && i18n.language !== saved) {
      i18n.changeLanguage(saved);
    }
  }, [i18n]);

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLangDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close dropdown when language changes
  useEffect(() => {
    setIsLangDropdownOpen(false);
  }, [i18n.language]);

  const toggleLangDropdown = (e) => {
    e.preventDefault();
    setIsLangDropdownOpen(!isLangDropdownOpen);
  };
  return (
    <>
      <HeaderPopupSearch />
      <MobileMenu />
      <header className="ot-header header-layout1">
        <div className="sticky-wrapper">
          {/* Main Menu Area */}
          <div className="menu-area">
            <div className="container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src={logo} alt="Secur" />
                    </Link>
                  </div>
                </div>
                <div className="col-auto">
                  <nav className="main-menu d-none d-lg-inline-block">
                    <MainMenu />
                  </nav>
                </div>
                <div className="col-auto">
                  <div className="header-button">
                    <div className="dropdown-link" ref={dropdownRef}>
                      <a 
                        className="dropdown-toggle icon-btn" 
                        href="#" 
                        role="button" 
                        id="headerThreeLangDropdown" 
                        aria-expanded={isLangDropdownOpen}
                        onClick={toggleLangDropdown}
                      >
                        <img src={`https://flagcdn.com/${flagCodes[i18n.language] || flagCodes.en}.svg`} alt={`Flag ${i18n.language}`} width="22" height="22"/>
                      </a>
                      <ul className={`dropdown-menu ${isLangDropdownOpen ? 'show' : ''}`} aria-labelledby="headerThreeLangDropdown">
                        <li>
                          {languages.map((lng) => (
                            <a key={lng} href="#" onClick={(e)=>{e.preventDefault(); changeLang(lng);}} className="dropdown-item">
                              <img src={`https://flagcdn.com/${flagCodes[lng]}.svg`} alt={`Flag ${lng}`} width="20" height="15" style={{marginRight: '8px'}}/>
                              {t(`languages.${lng}`, langLabels[lng])}
                            </a>
                          ))}
                        </li>
                      </ul>
                    </div>
                    <button type="button" className="icon-btn searchBoxToggler d-none d-lg-block"><i className="far fa-search"></i></button>
                    
                    <button 
                      type="button" 
                      className="ot-menu-toggle d-block d-lg-none"
                    >
                      <i className="far fa-bars"></i>
                    </button>

                    <Link to="/contact" className="ot-btn d-none d-xl-flex">{t('header.get_consultation')}<i className="far fa-long-arrow-right ms-2"></i></Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;